import React, { useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Container from "../components/Container";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../features/user/userSlice";
import { FiEdit } from "react-icons/fi";
import ApiResponseModal from "../components/ApiResponseModal";

let profileSchema = yup.object({
  firstname: yup.string().required("First Name is Required"),
  lastname: yup.string().required("Last Name is Required"),
  email: yup
    .string()
    .required("Email is Required")
    .email("Email Should be valid"),
  mobile: yup.number().required().positive().integer("Mobile No is Required"),
});

const Profile = () => {
  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});
  const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.auth.user);
  const [edit, setEdit] = useState(true);
const formik = useFormik({
  enableReinitialize: true, // IMPORTANT if userState loads async
  initialValues: {
    firstname: userState?.firstname || "",
    lastname: userState?.lastname || "",
    email: userState?.email || "",
    mobile: userState?.mobile || "",
  },
  validationSchema: profileSchema,
  onSubmit: async (values) => {
    try {
      await dispatch(
        updateProfile({ data: values, config2 })
      ).unwrap(); // 🔥 KEY FIX

      // ✅ Only if API truly succeeds
      setApiModal({
        show: true,
        type: "success",
        title: "Profile Updated",
        message: "Your profile has been updated successfully",
      });

      setEdit(true);
    } catch (error) {
      setApiModal({
        show: true,
        type: "error",
        title: "Update Failed",
        message:
          error?.message ||
          "Unable to update profile. Please try again.",
      });
    }
  },
});


  return (
    <>
        <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>
      <BreadCrumb title="My Profile" />
      <Container class1="cart-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="my-3">Update Profile</h3>

              <FiEdit className="fs-3" onClick={() => setEdit(false)} />
            </div>
          </div>
          <div className="col-12">
            <form action="" onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <div className="mb-3">
                  <label htmlFor="example1" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstname"
                    className="form-control"
                    id="example1"
                    disabled={edit}
                    value={formik.values.firstname}
                    onChange={formik.handleChange("firstname")}
                    onBlur={formik.handleBlur("firstname")}
                  />
                  <div className="error">
                    {formik.touched.firstname && formik.errors.firstname}
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="example2" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastname"
                    className="form-control"
                    id="example2"
                    disabled={edit}
                    value={formik.values.lastname}
                    onChange={formik.handleChange("lastname")}
                    onBlur={formik.handleBlur("lastname")}
                  />
                  <div className="error">
                    {formik.touched.lastname && formik.errors.lastname}
                  </div>
                </div>
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  disabled={edit}
                  aria-describedby="emailHelp"
                  value={formik.values.email}
                  onChange={formik.handleChange("email")}
                  onBlur={formik.handleBlur("email")}
                />
                <div className="error">
                  {formik.touched.email && formik.errors.email}
                </div>
                <div className="mb-3">
                  <label htmlFor="example3" className="form-label">
                    Mobile No
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-control"
                    id="example3"
                    disabled={true}
                    value={formik.values.mobile}
                    onChange={formik.handleChange("mobile")}
                    onBlur={formik.handleBlur("mobile")}
                  />
                  <div className="error">
                    {formik.touched.mobile && formik.errors.mobile}
                  </div>
                </div>
              </div>

              {edit === false && (
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              )}
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Profile;
